'use strict';

export default function() {
  function clearNotifications() {
    window.loadingIndicator.show($('#section-service-reminders__alert-content'));
    var bikeId = $('#bikeId').val();
    var currentRegion = $('#currentRegion').val();
    var currentLocale = $('#currentLocale').val();
    var ajaxUrl = '/' + currentRegion + '/' + currentLocale + '/my-account/clearNotifications/' + bikeId;
    $.ajax({
      type: 'POST',
      url: ajaxUrl,
      dataType: 'html',
      success: function(response) {
        var responseObject = JSON.parse(response);
        var result = responseObject.result;
        window.loadingIndicator.hide();
        if (result === true) {
          // copy and append each alert into dismissed section while removing the wrench div column
          var alertIndex = 0;
          var alertSelector = '#section-service-reminders__alert-container-' + alertIndex;
          while ($(alertSelector).length > 0) {
            $(alertSelector)
              .find('div')
              .first()
              .remove();
            $(alertSelector).appendTo($('#section-service-reminders__dismissed-content'));
            alertIndex++;
            alertSelector = '#section-service-reminders__alert-container-' + alertIndex;
          }
          // show the no-alerts message section and remove the alerts and archive button
          $('#section-service-reminders__alert-content').remove();
          $('#section-service-reminders__no-alerts-message').addClass('flex');
          // remove the no notifications history message
          $('#section-service-reminders-dismissed__no-history').remove();
        } else {
          var errorForm = responseObject.errorForm;
          if (errorForm === true) {
            var accErrorMsgs = responseObject.accErrorMsgs;
            if (accErrorMsgs) {
              if ($('#globalMessages').find('li').length === 0) {
                $('#globalMessages').append(
                  "<div class='row expand'><ul><li class='alert negative'>" + accErrorMsgs + '</li><ul></div>'
                );
              } else {
                $('#globalMessages div ul li:last').after("<li class='alert negative'>" + accErrorMsgs + '</li>');
              }
            }
          }
        }
      },
      error: function() {
        window.loadingIndicator.hide();
        if ($('#globalMessages').find('li').length === 0) {
          $('#globalMessages').append(
            "<div class='row expand'><ul><li class='alert negative'>Error clearing alerts.</li><ul></div>"
          );
        } else {
          $('#globalMessages div ul li:last').after("<li class='alert negative'>Error clearing alerts.</li>");
        }
      },
    });
  }

  $('#clearButton').on('click', function() {
    clearNotifications();
  });
}
